module.exports = __webpack_public_path__ + "static/6-58cc2e26522c18481f336781c96d3808.jpg";